<p>Current bill date: {{ dateStringFromISO8601(membership.end_date) }}</p>

<div class="form-group">
  <label for="newBillDate">New bill date</label>
  <app-date-picker [id]="'newBillDate'" [minDate]="minDate" [(content)]="newBillDate"></app-date-picker>
  <small class="form-text text-muted" *ngIf="dayDelta() !== null && dayDelta() !== 0">{{ abs(dayDelta()) }} {{ abs(dayDelta()) === 1 ? 'day' : 'days' }} {{ dayDelta() > 0 ? 'added' : 'removed' }}</small>
</div>

<div class="form-group">
  <label for="billDateNotes">Notes <span class="text-muted">(optional, saved to the activity log)</span></label>
  <textarea class="form-control" id="billDateNotes" rows="2" [(ngModel)]="notes"></textarea>
</div>

<div class="alert alert-warning" role="alert">
  <p class="mb-2">No prorated charge or refund is made. Moving the bill date later gives the customer membership days they have not paid for; moving it earlier takes away days they have already paid for. Add account credit separately if you want to compensate the customer.</p>
  <ng-container *ngIf="!isSubMonthlyMembershipInterval(membership.interval)">
    <p class="mb-0">The day of the month you choose becomes this customer's billing day for every future renewal.<ng-container *ngIf="membership.bill_day_of_month"> This membership normally bills on day {{ membership.bill_day_of_month }} of the month; this customer will bill on the chosen day instead.</ng-container></p>
  </ng-container>
</div>

<div class="alert alert-danger" role="alert" *ngIf="errorMessage">{{ errorMessage }}</div>
